import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { UnderMaintenanceComponent } from './under-maintenance.component';
import { UnderMaintenanceGuard } from './under-maintenance.guard';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: UnderMaintenanceComponent,
        canDeactivate: [UnderMaintenanceGuard]
      }
    ]),
    TranslocoModule,
  ],
  declarations: [UnderMaintenanceComponent],
})
export class UnderMaintenanceModule {}
